<template>
  <div class="content_main" id="content_main">
    <div style="margin-top: 10px">
      <a-button type="primary" @click="addcust">添加客户</a-button>
    </div>
    <div class="content_main_top">
      <a-input
      style="width: 300px; margin-right: 10px;"
        v-model="serchInfo.companyName"
        allowClear
        placeholder="企业名称"
        @keyup.enter.native="serch_get_lis"
      />
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" ghost @click="queryall"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="false"
        :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <!-- <a-table-column key="companyName" title="参数名称" ellipsis="true" data-index="companyName">
          <template scope="text,record"> {{ text }}客户代表 </template>
        </a-table-column> -->
         <a-table-column key="index" title="序号" data-index="index" width="80px"/>
        <a-table-column key="companyName" title="企业名称" data-index="companyName" width="160px"/>
        <!-- <a-table-column key="industryName" title="所属行业" ellipsis="true" data-index="industryName" /> -->
        <a-table-column key="address" title="企业地址" ellipsis="true" data-index="address" />
        <a-table-column key="customerName" title="联系人" ellipsis="true" data-index="customerName" />
        <a-table-column key="telephone" title="联系方式" ellipsis="true" data-index="telephone" />
        <a-table-column key="fixedTelephone" title="固定电话" ellipsis="true" data-index="fixedTelephone" />
        <a-table-column key="personScale" title="人员规模" ellipsis="true" data-index="personScale" />
        <a-table-column key="businessScope" title="经营范围" ellipsis="true" data-index="businessScope" />
        <a-table-column title="操作" width="180px">
          <template scope="text,record">
            <a @click="editCustomer(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="details(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="edit(record)">生成报价</a>
          </template>
        </a-table-column>
      </a-table>
      <div class="pageBottom">
         <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			      @showSizeChange="handleTableChange"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="handleTableChange"
          />
      </div>
    </div>
    <a-modal class="gufiiguy" :title="types == 0? '新增客户' : '编辑客户信息'" :visible="addUserVisible" @ok="addOk" @cancel="closeAddUser" width="70%">
      <a-form-model :model="form" :rules="rules" ref="addUserForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="userContainer">
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="企业名称"
                prop="companyName"
                :rules="{
                  required: true,
                  message: '请输入企业名称',
                  trigger: 'change',
                }"
              >
                <a-input v-model="form.companyName" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="8"> -->
              <!-- <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="所属行业"
                prop="industry"
                :rules="{
                  required: true,
                  message: '请选择所属行业',
                  trigger: 'change',
                }"
              >
               <a-input v-model="form.industry" placeholder="请输入"></a-input> -->
                <!-- <a-select allowClear placeholder="所属行业" v-model="form.industry" @change="changeName1">
                  <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                    {{ item.industryName }}
                  </a-select-option>
                </a-select> -->
              <!-- </a-form-model-item> -->
            <!-- </a-col> -->
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="所在地区"
                prop="location"
                :rules="{
                  required: true,
                  message: '请选择所在地区',
                  trigger: 'change',
                }"
              >
              <a-cascader  v-model="form.location" :options="LocationList" placeholder="请选择" @change="choseLocation" popupStyle="50px"/>
                <!-- :rules="{
                  required: true,
                  message: '请选择所在地区',
                  trigger: 'change',
                }" -->
  

<!-- <a-tree-select
:dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    v-model="form.location"
    style="width: 100%"
    allow-clear  
    placeholder="请选择"
    @change="choseLocation"
  > -->
    <!-- :tree-data="LocationList" -->
   <!-- <a-tree-select-node v-for="item in LocationList" :key="item.value" :value="item.value" :title="item.title" :selectable="false" >
        <a-tree-select-node v-for="item1 in item.children" :key="item1.value" :value="item1.value" :title="item1.title" :selectable="false">
             <a-tree-select-node v-for="item2 in item1.children" :key="item2.value" :value="item2.value" :title="item2.title" />
        </a-tree-select-node>
   </a-tree-select-node>
  
  </a-tree-select> -->
              </a-form-model-item>
            </a-col>
          
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }" 
                label="详细地址"
                prop="address"
                :rules="{
                  required: true,
                  message: '请输入详细地址',
                  trigger: 'change',
                }"
              >
                <a-input v-model="form.address" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="联系人"
                prop="customerName"
                :rules="{
                  required: true,
                  message: '请输入联系人',
                  trigger: 'change',
                }"
              >
                <a-input v-model="form.customerName" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="联系方式"
                prop="telephone"
                :rules="{
                  required: true,
                  message: '请输入联系方式',
                  trigger: 'change',
                }"
              >
                <a-input v-model="form.telephone" placeholder="请输入" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"></a-input>
              </a-form-model-item>
            </a-col>
        
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="固定电话"
              >
                <a-input v-model="form.fixedTelephone" placeholder="请输入" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" ></a-input>
              </a-form-model-item>
            </a-col>
              </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="邮箱" 
                >
                <a-input v-model="form.email" placeholder="请输入" ></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <!-- <a-row>
					<a-col :span="12" >
						<a-form-model-item label="隶属公司" prop="companyId">
							<a-select allowClear placeholder="隶属公司" v-model="form.companyId" @change="handlecompanyplan">
								<a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="隶属部门" prop="departmentId">
							<a-tree-select allowClear :treeData="deptTree" placeholder="隶属部门" :disabled="!this.form.companyId" v-model="form.departmentId"
							 treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        </div>
        <div class="title">
          <span>企业信息</span>
        </div>
        <div class="userContainer">
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="人员规模"
              >
                <a-input v-model="form.personScale" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="社会信用代码"
              >
                <a-input v-model="form.code" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="注册地址"
              >
                <a-input v-model="form.registerAddress" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="注册日期"
              >
              <a-date-picker v-model="form.registerTime" @change="useCarDateChange" format="YYYY-MM-DD"
							 allowClear style="width: 267px" placeholder="请选择" />

                <!-- <a-input v-model="form.registerTime" placeholder="请输入"></a-input> -->
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="法人代表"
              >
                <a-input v-model="form.representative" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="经营范围"
              >
                <a-input v-model="form.businessScope" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label-col="{ span: 3 }"
                class="model_span_form"
                :wrapper-col="{ span: 21 }"
                label="备注"
              >
                <a-input v-model="form.remark" placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="clearData"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="commitCoutomerData" v-if="types == 0"> 确定 </a-button>
        <a-button key="submit" type="primary" @click="addCoutomerData(record)"  v-if="types == 1"> 确定 </a-button>
      </template>
    </a-modal>
    <a-modal
      :model="allform"
      class="userDetail"
      :title="'客户详情'"
      :visible="userDetaileVisible"
      @cancel="userDetaileVisible = false"
      width="70%"
    >
      <div class="title">
        <span>基本信息</span>
      </div>
      <div class="userDetailContaier">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="企业名称"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{allform.companyName}}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="8">
            <a-form-model-item
              label="所属行业"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <span>{{ allform.industryName}}</span>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="8">
            <a-form-model-item
              label="所在地区"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <span>{{ allform.province }}{{allform.city}}{{allform.county}}</span>
            </a-form-model-item>
          </a-col>
     
          <a-col :span="8">
            <a-form-model-item
              label="详细地址"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.address }}</span>
            </a-form-model-item>
          </a-col>
             </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="联系人"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <span>{{ allform.customerName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="联系方式"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <span>{{ allform.telephone }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="固定电话"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.fixedTelephone }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
          
        <a-row>
            <a-col :span="8">
            <a-form-model-item
              label="邮箱"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.email }}</span>
            </a-form-model-item>
          </a-col>
           </a-row>
      </div>
      <div class="title">
        <span>企业信息</span>
      </div>
      <div class="userDetailContaier ">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="人员规模"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.personScale}}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="社会信用代码"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span> {{  allform.code }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="注册地址"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.registerAddress}}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="注册日期"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.registerTime}}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="法人代表"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.representative}}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="经营范围"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.businessScope }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="备注"
              class="model_span_form"
              :label-col="{ span: 9 }"
              :wrapper-col="{ span: 15 }"
            >
              <!-- <span>{{ mdl.title }}</span> -->
              <span>{{ allform.remar }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
      <template slot="footer">
        <a-button key="back" @click="userDetaileVisible = false"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="userDetaileVisible = false"> 确定 </a-button>
      </template>
    </a-modal>
  
      <Generate :propRowData="rowData" :generateVisible="generateVisible" @visibleState="visibleState" :UUID="UUID"></Generate>
      <!-- @visibleState="visibleState -->
   
  </div>
</template>

<script>
import { generateUUID } from './generateQuotation/components/getUUID.js'
import { getDeptListEnable2 } from '@/api/system'
import {
  districts,
  companyInfo_add,
  customer_add,
  industryInfo,
  customerService,
  customerService_details,
  customerService_put,
  customerInfo_details,
  quotation_details,
  customerInfo,
  customerInfo_edit,
  companyInfo_details
//   customerInfo_details
} from '@/api/Industry'
import { tree_all } from '@/api/purchase'
import Generate from './generateQuotation/generate.vue'
export default {

  components: {
    Generate,
  },
  data() {
    return {
      // UUID: '',
    generateVisible: false,
    rules: {

        },
	   // 用户信息列表
		customerInfo: {},
      //客户详情显示与隐藏
      userDetaileVisible: false,
      // 存放所有地区的数组
      LocationList: [],
      // 添加弹框显示与隐藏
      addUserVisible: false,
      //
      serchInfo: {
        companyName: '',
      },
      lis: {
          index: 1,
    },
     pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
      // pagination: {
      //   current: 1,
      //   pageSize: 10,
      //   total: 0,
      //   pageSizeOptions: ['10', '20', '30', '40', '50'],
      //   showLessItems: true,
      //   showSizeChanger: true,
      // },
      scroll_y: 150,
      loading: false,
      allvisible: false,
      allform: {},
      types: '',
      addvisible: false,
      datalist: [],
      // 添加表单绑定数据
      form: {
        //地址
         location: '',
        province: '',
        city: '',
        county: '',
        id: '',
        // 公司名称
        companyName: '',
        // //所属行业
        // industry: '',
        // 详细地址
        address: '',
        // 联系人
        customerName: '',
        // 联系电话
        telephone: '',
        // 固定电话
        fixedTelephone: '',
        //邮箱
        email: '',
        // 人员规模
        personScale: '',
        // 社会信用代码
        code: '',
        // 注册地址
        registerAddress: '',
        // 注册日期
        createTime: '',
        // 法人代表
        representative: '',
        // 经营范围
        businessScope: '',
        // 备注
        remar: '',
        // //所属行业
        // industryId: '',
        //所在地区
        region: '',
        remark: undefined,
        departmentId: undefined,
        companyId: undefined,
      },
      companylist: [],
      deptTree: [],
      types: '',
      rowIdCourrent: '',
      rowData: ''
    }
  },
  // // 父组件中返回要传给下级的数据
  //   provide(){
  //       return{
  //           propRowData: this.rowData
  //       }
  //   },
  mounted() {
    
     // 获取地区数据
    districts().then((res) => {
      // console.log(this.$store.getters, 'this.$store.getters===================================')
      console.log(res.data.tree, 'res.data.tree=========================')
      // this.LocationList = res.data.tree
        const list = res.data.tree
        list.forEach( item => {
          item.value = item.id
          item.label = item.extName
          if(item.children) {
             item.children.forEach( item1 => {
                item1.value = item1.id
                item1.label = item1.extName
                 item1.children.forEach( item2 => {
                  
                item2.value = item2.id
                item2.label = item2.extName
                if(item2.children.length == 0) {
                     delete item2['children']
                  }
             })
             })
           
          }else {
            delete item['children']
          }


        })   
        this.LocationList = list 
        console.log(list , 'list ==========================')
    })
	
    
    // districts().then((res)=>{
    // 	console.log(res.data, 'res.data+++++++++++++++++++')
    // 	this.LocationList = res.data
    // })
    //获取所属行业
    // industryInfo().then((res) => {
    //   this.datalist = res.tree
    // })
    tree_all().then((res) => {
      this.companylist = res.data[0]
    })
    this.get_list()
    	this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
        console.log(max_h, 'max_h===========================')
				setTimeout(() => {
          console.log( $('.ant-table-header').height(), '11111111111111111111111')
					this.scroll_y = max_h - $('.ant-table-header').height() -170
          console.log(this.scroll_y, 'scroll_y=====================')
				}, 1000)
			})
    // this.$nextTick(() => {
    //   var max_h = $('#content_main').height()
    //   console.log(max_h, 'max_h======================')
    //   console.log($('.ant-table-header').height() , '2222222222222222222')
    //   // setTimeout(() => {
    //     this.scroll_y = max_h - 200
    //   // }, 1000)
    // })
  },
  methods: {
    onLoadData(treeNode) {
      console.log(treeNode, 'treeNode========================')

    },
    //时间选择
    useCarDateChange(value, dateString) {
				this.form.registerTime = dateString
			},
    //地区选择
    choseLocation(e) {
      
      this.form.region = e[2]
      this.LocationList.forEach(item1 => {
        if(item1.id == e[0]) {
           this.form.province = item1.extName
           if(item1.children) {
            item1.children.forEach(item2 => {
               if(item2.id == e[1]){
                 this.form.city = item2.extName
               }
                 if(item2.children) {
                 item2.children.forEach(item3 => {
                  if(item3.id == e[2]) {
                     this.form.county = item3.extName
                  }
                 })
                 }

            })
           }

        }
      })
      console.log(e,'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
      // this.LocationList.forEach(item => {
      //   if(item.id == e) {
      //     this.form.location = item.extName
      //   } else if (item.children.length != 0) {
      //     item.children.forEach(item1 => {
      //       if (item1.id == e) {
      //          this.form.location = item1.extName
      //       }  else if (item1.children.length != 0) {
      //     item1.children.forEach(item2 => {
      //        if (item2.id == e) {
      //             this.form.county = item2.extName
      //          item.children.forEach(item1 => {
      //            if(item1.id == item2.pid) {
      //            //省
      //            this.form.city = item1.extName
      //            this.LocationList.forEach(item => {
      //              if(item.id == item1.pid) { 
      //              this.form.province = item.extName
      //               this.form.location = this.form.province + this.form.city +  this.form.county
      //          //区
      //          }
      //            })
      //           }
      //         })
      //       }
      //     })
      //    }
      // })
  //    }
  // })
  },
    // closeVisible(data) {
    //   this.generateVisible = data

    // },
   
    visibleState(data) {
          this.generateVisible = data
          console.log(this.generateVisible, 'generateVisible2======================')
      },
    //客户编辑页面
    editCustomer(row) {
    //   	companyInfo_details(row.id).then((res) => {
    //   if(res.code == 200) {

    //     this.form = res.data
    //     console.log( this.form , ' this.form ========================')
    //   }  else {
    //       this.$message.error(res.msg)
    //     }
		// })
    this.rowIdCourrent = row.id
    customerInfo_details(row.id).then((res) => {
      // var location = res.data.province + res.data.city +  res.data.county
      var location = new Array(3)
      // location[0] = Number(res.data.province)
      // location[1] = Number(res.data.city)
      // location[2] = Number(res.data.county)
     
       this.LocationList.forEach(item => {
        if(item.id ==  res.data.region) {
         location[0] = item.id
        } else if (item.children.length != 0) {
          item.children.forEach(item1 => {
            if (item1.id ==  res.data.region) {
              location[1] = item1.id
            }  else if (item1.children.length != 0) {
          item1.children.forEach(item2 => {
             if (item2.id ==  res.data.region) {
                 location[2] = item2.id
               item.children.forEach(item1 => {
                 if(item1.id == item2.pid) {
                 //省
                 location[1] = item1.id
                 this.LocationList.forEach(item => {
                   if(item.id == item1.pid) { 
                   location[0] = item.id
                    // this.form.location = this.form.province + this.form.city +  this.form.county
               //区
               }
                 })
                }
              })
            }
          })
         }
      })
      // this.form.location = location
     }
  })
        Object.assign( res.data,{location:location })
        this.form = res.data
        console.log(this.form.location, 'location========================')
      })
    this.addUserVisible = true
    this.types = 1
    },
    // 关闭添加弹窗
    closeAddUser() {
      this.$refs.addUserForm.clearValidate()
      this.$refs.addUserForm.resetFields()
      this.addUserVisible = false
    },
    // 所属行业改变事件
    // changeName1(value) {
    //   this.datalist.forEach((item) => {
    //     if (item.id == value) {
    //       this.form.industryName = item.industryName
    //     }
    //   })
    // },
    // 所属地区改变事件
    changeName2(value) {
      this.LocationList.forEach((item) => {
        if (item.id == value) {
          this.form.region = item.extName
        }
      })
    },
    // 取消事件
    clearData() {
      this.$refs.addUserForm.clearValidate()
      this.$refs.addUserForm.resetFields()
      this.addUserVisible = false
      //   this.form = []
    },
    //修改表单数据
    addCoutomerData() {
      console.log('11111111111111111111111111111111111111111111')
      this.$refs.addUserForm.validate((valid) => {
        //表单校验
        if (valid == true) {
          Object.assign(this.form,{id:this.rowIdCourrent})
          customerInfo_edit(this.form).then((res) => {
                if (res.code == 200) {
                  this.get_list()
                  this.$refs.addUserForm.clearValidate()
                  this.$refs.addUserForm.resetFields()
                  this.addUserVisible = false
                  this.$message.success('保存成功')
                  this.show(this.record)
                  
                } else {
                  this.$message.error(res.msg)
                  return
                }
              })
        } else {
          this.$message.error('请填写必填信息')
        }
      })
      // 刷新数据列表
      this.get_list()

    },
    //提交表单数据
    commitCoutomerData() {
        console.log(this.form, 'this.form===================')
      // districts().then((res)=>{
      // 	console.log(res.rows, 'res.rows+++++++++++++++++++')
      // 	this.LocationList = res.rows
      // })
      this.$refs.addUserForm.validate((valid) => {
        //表单校验
        if (valid == true) {
          console.log(valid, 'valid++++++++++++++++++++++++')
          console.log(this.form, 'this.form===================')
          customer_add(this.form).then((res) => {
                if (res.code == 200) {
                  //刷新数据列表
                  this.get_list()
                  this.$refs.addUserForm.clearValidate()
                  this.$refs.addUserForm.resetFields()
                  this.addUserVisible = false
                  this.$message.success('保存成功')
                  this.show(this.record)
                  
                } else {
                  this.$message.error(res.msg)
                  return
                }
              })
        } else {
          this.$message.error('请填写必填信息')
        }
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    handlecompanyplan(value) {
      this.deptTree = []
      this.form.departmentId = undefined
      this.$nextTick(() => {
        getDeptListEnable2().then((res) => {
          const data = res.rows
          if (data.length > 0) {
            const min = Math.min(...data.map((m) => m.parentId))
            this.buildtree2(data, this.deptTree, this.form.companyId)
          }
        })
      })
    },
    addcust() {
      this.form = {}
      this.addUserVisible = true
      this.types = 0
      console.log(this.LocationList, 'this.LocationList+++++++++++++++++++')
   
      
    },
    //搜索
    serch_get_lis() {

      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.loading = true
      this.get_list()
    },
    //获取客户列表
    get_list() {
      customerInfo({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        companyName: this.serchInfo.companyName,
      }).then((res) => {
        if (res.code == 200) {
        //   this.lis = res.data
           let newData = res.data.map((item, index) => {
        item.key = index + Math.random()
        item.index = index + 1
        return item
      })
       this.lis = newData
        //   this.index = this.lis.index + 1
          console.log(this.lis,'this.lis3333++++++++++++++++++++++++++++++++++')
          const pagination = {
            ...this.pagination,
          }
          pagination.totalCount = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    details(row) {
		// 获取详情数据
		// companyInfo_details(row.id).then((res) => {
    //   if(res.code == 200) {
    //     this.allform = res.data
    //   }  else {
    //       this.$message.error(res.msg)
    //     }
		// })
		// console.log(this.customerInfo,'this.customerInfo+++++++++++++++++++++++++')

      customerInfo_details(row.id).then((res) => {
        this.allform = res.data
      })
      this.userDetaileVisible = true
    //   this.types = 0
    },
    edit(row) {
    //生成uuid
    //  this.UUID = generateUUID(20, 16)
    //  console.log(this.UUID, 'this.UUID=========================')
    //  把当前行row的信息传递给孙子组件
    this.rowData = row
     console.log(this.rowData, 'this.rowData============================');

      this.generateVisible = true
       console.log(this.generateVisible, 'this.generateVisible============================');
      // this.generateVisible = true
      // //获取当前行数据
      // quotation_details(row.id).then((res) => {
      // console.log(res, 'res============================');
      // })
    },
    getOkAll() {
      this.$refs.allForm.validate((valid) => {
        if (valid) {
          customerService_put(this.allform).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.allvisible = false
              this.get_list()
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })
    },
    queryall() {
      this.serchInfo = {}
    },
  },
}
</script>

<style scoped>
.content_main {
  padding: 10px;
}

.userContainer {
    background-color: #fff;
    padding: 15px 0;
    border-radius: 10px;
    padding-left: 10px;
   
}

.userDetailContaier {
	padding: 0px 24px 24px 24px;
    background-color: #fff;
}
/* .ant-modal-body {
	background-color: #F8F8F8 !important
  
} */
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
} 
</style>
